import React, { useState } from 'react';
import CalmPanel from './CalmPanel';

export default function CalmFloatingButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-[180] w-14 h-14 rounded-full bg-gradient-to-br from-[#A2D2FF] via-[#C8B6FF] to-[#FFC8DD] border-4 border-black shadow-[0_6px_0_0_rgba(0,0,0,1)] flex items-center justify-center hover:scale-105 active:translate-y-1 active:shadow-[0_2px_0_0_rgba(0,0,0,1)] transition-all animate-calm-pulse"
        title="Lugnt just nu 🌿"
        aria-label="Lugnt just nu"
        data-testid="calm-floating-btn"
      >
        <span className="text-2xl">🌿</span>
      </button>
      <CalmPanel open={open} onClose={() => setOpen(false)} />
      <style>{`
        @keyframes calm-pulse {
          0%, 100% { box-shadow: 0 6px 0 0 rgba(0,0,0,1), 0 0 0 0 rgba(200,182,255,0.5); }
          50%      { box-shadow: 0 6px 0 0 rgba(0,0,0,1), 0 0 0 14px rgba(200,182,255,0); }
        }
        .animate-calm-pulse { animation: calm-pulse 3s ease-in-out infinite; }
      `}</style>
    </>
  );
}
